__turbopack_context__.v({
  "appType": "Lfib8G_appType",
  "claret": "Lfib8G_claret",
  "display": "Lfib8G_display",
  "page": "Lfib8G_page",
  "square": "Lfib8G_square",
});
